import React from 'react'
import Contract from '../../../components/customer/contracts/contract/Contract'
import RoutesHelper from '../../../helpers/RoutesHelper'

const CustomerContract = () => {
    return <Contract route={RoutesHelper.views.Customer.contracts.Contract} />
}

export default CustomerContract
